query Tests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_test_runsSearchInsensitive
	$textSearchExact: wsdk_test_runsSearchInsensitive
	$sort: wsdk_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
) {
	wsdk_test_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		text_equals: $textSearchExact
		property_ids_eq_any_item: $propertiesFilter
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}

query RecentTests(
	$offset: Int!
	$limit: Int!
	$textSearch: wsdk_latest_test_runsSearchInsensitive
	$textSearchExact: wsdk_latest_test_runsSearchInsensitive
	$sort: wsdk_latest_test_runsSort
	$daysAmountFilter: ConditionInt
	$propertiesFilter: ConditionID
) {
	wsdk_test_runs: wsdk_latest_test_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		property_ids_eq_any_item: $propertiesFilter
	) {
		run_id
		test_name
		total_issues
		critical_issues
		run_time
		custom_fields
		environments
		flows
		test_path
		property_ids
	}
	total: wsdk_latest_test_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		text_equals: $textSearchExact
		property_ids_eq_any_item: $propertiesFilter
	) {
		run_id_count
	}
	unfiltered_total: wsdk_test_runs {
		run_id_count
	}
}
